import React, { useState, useEffect } from "react";

import BaseWindow from "./public/BaseWindow";
import { inputStyles } from "../styles/styles";
import { Grid, Button, Select, MenuItem, Box, Tooltip } from "@material-ui/core";
import { infoTexts } from "../utils/enums.ts";
import { DataGrid } from "@material-ui/data-grid";
import PaymentPlanDialog from "./PaymentPlanDialog";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { getNextStep, prmData } from "../utils/enums.ts";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getInterestRate,
  getProductInfo,
} from "../store/limitAndPaymentInformation/thunkActions";
import {
  resetLimitAndPaymentInfo,
  updateLimitAndPaymentInfo,
} from "../store/limitAndPaymentInformation/actions";
import {
  getErrorMessage,
  getNumberFormat,
  getPreviousStep,
  stateHandler,
} from "../utils/enums";
import { addProcessContext } from "../store/processContext/actions";
import NotFoundPage from "./public/NotFoundPage";
import InfoIcon from "@material-ui/icons/Info";
import { updateAlert } from "../store/alert/actions";
import InterestRatesColumns from "./columns/interestRatesColumns";
import { updateInsuranceSelection } from "../store/limitAndPaymentInformation/actions";
import { updateUnsuccessMsg } from "../store/unsuccess/actions";
import { getTransferContent } from "../utils/transferContent";

function LimitAndPaymentInformation(props) {
  const classes = inputStyles();
  let history = useHistory();
  let { uuid } = useParams();
  const pageName = "limitAndPaymentInformation";
  const inputDataDefaultState = {
    creditAmount: {
      value: "",
      error: false,
      helperText: "",
    },
    instalment: {
      value: "",
      error: false,
      helperText: "",
    },
  };

  const [inputData, setInputData] = useState(inputDataDefaultState);

  const [selectionModel, setSelectionModel] = React.useState([]);

  const columns = React.useMemo(() => [
    { field: "id", headerName: "ID", width: 90, hide: true },
    {
      field: "limitType",
      headerName: "Limit Tipi",
      headerAlign: "center",
      sortable: false,
      minWidth: 90,
      flex: 1,
      selected: true,
      valueGetter: (params) => {
        return params.value === "TTK" ? "Ticari Taksitli Kredi" : params.value;
      },
    },
    {
      field: "installmentNumber",
      headerName: "Taksit",
      width: 70,
      sortable: false,

      align: "center",
      headerAlign: "center",
    },
    {
      field: "interestRate",
      headerName: "Faiz",
      sortable: false,

      width: 70,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => {
        return "%" + getNumberFormat(params.value);
      },
    },
    {
      field: "insuranceFlag",
      headerName: "Sigorta",
      sortable: false,
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Select
            value={params.row.insuranceSelection}
            style={{ fontSize: "13px!important" }}
            onChange={(ev) => {
              props.actions.updateInsuranceSelection({
                id: params.row.id,
                insuranceSelection: ev.target.value,
              });
            }}
            disabled={
              params.row.insuranceFlag === "1" ||
              params.row.insuranceFlag === "2"
            }
            inputProps={{ style: { fontSize: "13px!important" } }}
          >
            <MenuItem value={"Seçiniz"}>Seçiniz..</MenuItem>
            <MenuItem value={"Evet"}>Evet</MenuItem>
            <MenuItem value={"Hayır"}>Hayır</MenuItem>
          </Select>
        );
      },
    },
    {
      field: "usableAmount",
      headerName: "Kullanılabilir Limit",
      sortable: false,
      flex: 1,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const showInfo = params.row.insuranceSelection === "Evet";
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {getNumberFormat(params.value)}
            {showInfo && (
              <Tooltip
                title={
                  infoTexts.BM0003_PREFIX +
                  infoTexts.BM0003_SUFFIX
                }
              >
                <InfoIcon fontSize="small" color="disabled" style={{ marginLeft: 5 }} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ], [
    props.actions,
  ]);

  useEffect(() => {
    if (props.processContext.stepName === pageName) {
      props.actions
        .getProductInfo({
          externalId: uuid,
        })
        .then((resp) => {
          if (resp) {
            console.log()
            if (resp.resultCode === "4007134") {
              props.actions.updateUnsuccessMsg(resp.errorText);
              const nextStepName = "unsuccess";
              props.actions.addProcessContext({ stepName: nextStepName });
              history.push("/" + uuid + "/" + nextStepName);
            } else {
              props.actions
                .getInterestRate({
                  companyCode: props.processContext.companyCode,
                  agencyCode: props.processContext.agencyCode,
                  externalId: uuid,
                })
                .then((hasRows) => {
                  if (hasRows) {
                    setSelectionModel([0]);
                  }
                });
            }
          }
        });
    }

    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        devamClick();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const devamClick = () => {
    if (
      props.limitAndPaymentInformation?.paymentPlanData?.simulationCreated !==
      true
    ) {
      props.actions.updateAlert({
        severity: "error",
        text: getErrorMessage("MS0026"),
        open: true,
      });
      return;
    }

    const selectedIns = props.limitAndPaymentInformation?.interestList?.find(
      (el) => el.id == selectionModel[0]
    );

    // insurance Check
    if (
      selectedIns.insuranceFlag === "1" &&
      (props.limitAndPaymentInformation?.insuranceOffer
        ?.insuranceOfferCreated !== true ||
        props.limitAndPaymentInformation?.insuranceOffer
          ?.insuranceDocumentId === "0" ||
        props.limitAndPaymentInformation?.insuranceOffer
          ?.insuranceDocumentId === "")
    ) {
      props.actions.updateAlert({
        severity: "error",
        text: getErrorMessage("MS0023"),
        open: true,
      });
      return;
    }
    // tarifee check

    if (
      (selectedIns.tarifeFlag === "1" || selectedIns.tarifeFlag === "3") &&
      props.limitAndPaymentInformation?.tarifeOffer?.tarifeOfferCreated !== true
    ) {
      props.actions.updateAlert({
        severity: "error",
        text: getErrorMessage("MS0023"),
        open: true,
      });
      return;
    }

    if (!props.limitAndPaymentInformation?.productList) {
      props.actions.updateAlert({
        severity: "error",
        text: "Ürün Bilgisi Alınamadı",
        open: true,
      });
      return;
    }
    // simulation check

    props.actions.addProcessContext({
      criterList: [
        {
          criter: selectedIns?.limitType,
          criterAmount: props.processContext.amount,
        },
      ],
      paymentPlanDocId:
        props.limitAndPaymentInformation.paymentPlanData?.documentId,
      limitType: selectedIns?.limitType,
      gksAmount: props.limitAndPaymentInformation.paymentPlanData?.gksAmount,
      installmentNumber: selectedIns?.installmentNumber,
      interestRateId: selectedIns?.interestRateId,
      ttkInfo: {
        usableAmount:
          props.limitAndPaymentInformation?.productList[0]?.usableAmount,
        installmentRate: selectedIns?.interestRate,
        usedType: props.limitAndPaymentInformation?.productList[0]?.limitType,
        usedAmount: props.processContext.amount,
      },
      kvkkDocument:
        props.limitAndPaymentInformation.paymentPlanData?.kvkkDocument,
      canSendMailForDocument: props.limitAndPaymentInformation.canSendMailForDocument
    });

    //history.push(getNextStep(pageName, { nextStatus: true, result: "0" }));
    const nextStepName = getNextStep(
      pageName,
      stateHandler(props.processContext.appState, "simulationCreated").result
    );
    props.actions.addProcessContext({ stepName: nextStepName });
    history.push(nextStepName);
  };

  const geriClick = () => {
    const prevStepName = getPreviousStep(pageName);
    props.actions.addProcessContext({
      paymentPlan: undefined,
      refundAmount: undefined,
      insurancePrice: undefined,
      tarifeePrice: undefined,
    });
    props.actions.resetLimitAndPaymentInfo();
    props.actions.addProcessContext({ stepName: prevStepName });
    history.push(prevStepName);
  };

  const setInputDataErrorChange = (
    prevState,
    propName,
    equalVal,
    helperText,
    type
  ) => {
    let compairingVal = "";
    switch (type) {
      case "length":
        compairingVal = prevState[propName].value.length;
        break;
      default:
        compairingVal = prevState[propName].value;
        break;
    }

    if (compairingVal < equalVal) {
      return {
        ...prevState,
        [propName]: {
          value: prevState[propName].value,
          error: true,
          helperText,
        },
      };
    } else {
      return {
        ...prevState,
        [propName]: {
          value: prevState[propName].value,
          error: false,
          helperText: "",
        },
      };
    }
  };

  const validationCheck = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "creditAmount",
        1,
        prmData.MS0008,
        "length"
      );
      prevState = setInputDataErrorChange(
        prevState,
        "instalment",
        1,
        prmData.MS0009,
        "length"
      );

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });

      return prevState;
    });

    return valid;
  };

  const onSelectedInterestRateChange = (newSelectionModel) => {
    // usableAmount check

    let selectionChanged = false;

    setSelectionModel((prevModel) => {
      if (
        newSelectionModel.length === 0 ||
        (newSelectionModel.length === 1 &&
          prevModel[0] === newSelectionModel[0])
      ) {
        return prevModel;
      } else {
        selectionChanged = true;
        return newSelectionModel.filter((newId) => !prevModel.includes(newId));
      }
    });

    if (selectionChanged) {
      props.actions.addProcessContext({
        paymentPlan: undefined,
        refundAmount: undefined,
        insurancePrice: undefined,
        tarifeePrice: undefined,
      });
      props.actions.updateLimitAndPaymentInfo({
        paymentPlanData: null,
        insuranceOffer: null,
        tarifeOffer: null,
      });
    }
  };

  const rowHeight = 40;
  const headerHeight = 40;

  const interestCount = props.limitAndPaymentInformation?.interestList?.length || 0;
  const gridHeight = headerHeight + Math.min(interestCount, 5) * rowHeight + 2; // +2 for borders

  return props.processContext.stepName !== pageName ? (
    <NotFoundPage />
  ) : (
    <BaseWindow isBasket={true}>
      <Grid item xs={12}>
        <p className={classes.p}>
          {getTransferContent(props.processContext.doTransferToCompany).productListInfo}
        </p>
      </Grid>

      <Grid item xs={12}>
        <Box sx={{
          height: gridHeight,
          width: "100%"
        }}>
          <DataGrid
            rows={props.limitAndPaymentInformation?.interestList || []}
            columns={columns}
            style={{ fontSize: 12 }}
            rowHeight={rowHeight}
            headerHeight={headerHeight}
            loading={props.limitAndPaymentInformation?.interestList === null}
            hideFooter
            density="compact"
            autoHeight={false}
            hideFooterPagination={true}
            selectionModel={selectionModel}
            checkboxSelection
            disableColumnMenu={true}
            disableColumnFilter={true}
            disableColumnSelector={true}
            sx={{
              "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
              {
                display: "none",
              },
            }}
            onSelectionModelChange={onSelectedInterestRateChange}
            onRowClick={(el) => {
              setSelectionModel([el.id]);
            }}
          />
        </Box>
      </Grid>

      {/*
      <Grid container item>
        <Grid item xs={4}>
          <p className={classes.p}>Kredi Tutarı</p>
          <FormControl
            size="small"
            style={{ width: "100%" }}
            error={inputData.creditAmount.error}
          >
            <BaseTextField
              required
              value={inputData.creditAmount.value}
              type={"number"}
              onChange={(ev) =>
                inputDataChange("creditAmount", ev.target.value)
              }
            />
            <FormHelperText>{inputData.creditAmount.helperText}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={4}>
          <p className={classes.p}>Taksit Sayısı</p>
          <FormControl
            size="small"
            style={{ width: "100%" }}
            error={inputData.instalment.error}
          >
            <Select
              required
              className={classes.textField}
              size="small"
              variant="outlined"
              value={inputData.instalment.value}
              onChange={(ev) => inputDataChange("instalment", ev.target.value)}
            >
              {[
                ...Array(
                  parseInt(
                    rows
                      .find((el) => el.id == selectionModel[0])
                      .instalment.split("-")[1]
                  ) +
                    1 -
                    parseInt(
                      rows
                        .find((el) => el.id == selectionModel[0])
                        .instalment.split("-")[0]
                    )
                ).keys(),
              ].map((el, idx) => {
                return (
                  <MenuItem
                    key={el}
                    value={
                      idx +
                      parseInt(
                        rows
                          .find((el) => el.id == selectionModel[0])
                          .instalment.split("-")[0]
                      )
                    }
                  >
                    {idx +
                      parseInt(
                        rows
                          .find((el) => el.id == selectionModel[0])
                          .instalment.split("-")[0]
                      )}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText>{inputData.instalment.helperText}</FormHelperText>
          </FormControl>
        </Grid>
            </Grid>*/}
      <Grid container item style={{ marginTop: 30 }}>
        <PaymentPlanDialog
          creditAmount={props.processContext.amount}
          installmentNumber={
            props.limitAndPaymentInformation?.interestList?.find(
              (el) => el.id == selectionModel[0]
            )?.installmentNumber
          }
          interestRateId={
            props.limitAndPaymentInformation?.interestList?.find(
              (el) => el.id == selectionModel[0]
            )?.interestRateId
          }
          selectedInterestRate={props.limitAndPaymentInformation?.interestList?.find(
            (el) => el.id == selectionModel[0]
          )}
          uuid={uuid}
          productType={props.processContext.productType}
        />
        {/*<Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={geriClick}
        >
          Geri
        </Button>*/}
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={devamClick}
        >
          Devam
        </Button>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    limitAndPaymentInformation: state.limitAndPaymentInformation,
    processContext: state.processContext,
    alert: state.alert,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      getProductInfo: bindActionCreators(getProductInfo, dispatch),
      getInterestRate: bindActionCreators(getInterestRate, dispatch),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
      updateUnsuccessMsg: bindActionCreators(updateUnsuccessMsg, dispatch),
      updateLimitAndPaymentInfo: bindActionCreators(
        updateLimitAndPaymentInfo,
        dispatch
      ),
      updateInsuranceSelection: bindActionCreators(
        updateInsuranceSelection,
        dispatch
      ),
      resetLimitAndPaymentInfo: bindActionCreators(
        resetLimitAndPaymentInfo,
        dispatch
      ),
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LimitAndPaymentInformation);
